import { render, staticRenderFns } from "./ReassessmentSummary.vue?vue&type=template&id=3927b871"
import script from "./ReassessmentSummary.vue?vue&type=script&lang=js"
export * from "./ReassessmentSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports